"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Refresh = void 0;
const react_1 = __importDefault(require("react"));
const Refresh = ({ size, color }) => {
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 52 52", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M16.375 20.664H7v-9.375", stroke: color || '#25CFBB', strokeWidth: "3.566", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M37.936 14.034a17.188 17.188 0 0 0-24.307 0L7 20.664M33.786 30h9.375v9.375", stroke: color || '#25CFBB', strokeWidth: "3.566", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M12.225 36.63a17.188 17.188 0 0 0 24.306 0l6.63-6.63", stroke: color || '#25CFBB', strokeWidth: "3.566", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.Refresh = Refresh;
